import { useTranslation as useTranslation$1 } from 'react-i18next';
import { useSiteContext } from '@zooplus/commons-lang';

const useTranslation = () => {
    const { site } = useSiteContext();
    return useTranslation$1(`cart-assets/cart-provider/locales/${site.realm}`);
};

export { useTranslation };
//# sourceMappingURL=useTranslation.js.map
